import { render, staticRenderFns } from "./product-item-movements.vue?vue&type=template&id=b851f938"
import script from "./product-item-movements.vue?vue&type=script&lang=js"
export * from "./product-item-movements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports